import _ from 'lodash'
import general from '../general.js'
import sortable from '../sortable.js'
import xhrModule from '../xhrModule.js'
import formResourcesManager from './formResourcesManager.js'
import editableReferenceItem from './editableReferenceItem.js'

import store from '../../store.js'

var editableRefInt = 0

var editableReference = function (options) {
	return {
		count: 0,
		init: function () {
			this.wrapper = options.mainContainer
			this.settings = options.settings
			this.callback = options.callback
			this.languages = options.languages
			this.currentLang = options.currentLang
			this.uuid = options.uuid
			this.routeChangeSuccess = options.routeChangeSuccess
			this.defaultLang = options.defaultLang
			this.startUniform = options.startUniform
			this.permissions = null
			this.referenceContainers = {}

			if (this.settings.maxvalues) {
				this.maxEditableReferences = this.settings.maxvalues.value
			} else {
				this.maxEditableReferences = 0
			}

			var referencedEntityID = this.settings.referenceId.value

			// get the CMS form for this entity
			formResourcesManager.fetchForm(this.fetchReferencedFormCompleted.bind(this), referencedEntityID)

			// get the entity
			var entities = formResourcesManager.entities
			for (var i = entities.length - 1; i >= 0; i--) {
				if (entities[i].id == referencedEntityID) {
					this.fetchEntityCompleted(entities[i])
					break
				}
			}
		},

		fetchEntityCompleted: function (data) {
			this.entity = data
			this.permissions = general.checkPermissions(this.entity.privileges, store.getters.roles)
			this.startSetup()
		},

		fetchReferencedFormCompleted: function (data) {
			// pick the first one to make sure we have the CMS form
			this.referencedFormClone = _.cloneDeep(data[Object.keys(data)[0]])
			this.referencedForm = _.cloneDeep(data[Object.keys(data)[0]])
			this.startSetup()
		},

		startSetup: function () {
			if (!this.entity || !this.referencedForm) return

			// prefill
			this.fetchDataToPrefill()

			// create container for editable fields
			this.editableReferencesContainer = document.createElement('div')
			this.editableReferencesContainer.className = 'items-wrapper nested-sortable main-sortable add-template-container draggable-container'

			this.wrapper.appendChild(this.editableReferencesContainer)

			if (this.permissions.add) {
				// create add button
				this.createButton = document.createElement('button')
				this.createButton.className = 'btn btn-add-reference-block'
				var icon = document.createElement('i')
				icon.className = 'fa fa-plus'
				var label = document.createElement('span')
				label.innerHTML = 'Add block'

				this.createButton.appendChild(icon)
				this.createButton.appendChild(label)
				this.wrapper.appendChild(this.createButton)

				this.createButton.addEventListener('click', this.addEditableReferenceForm.bind(this))
			}

			// setup draggable for this container
			sortable({
				'container': this.editableReferencesContainer
			}).init()
		},

		fetchDataToPrefill: function () {
			var joinedArray = ''

			if (this.uuid && this.uuid[0] !== 'null') {
				if (general.isJson(this.uuid)) {
					this.uuid = JSON.parse(this.uuid)
				}
				joinedArray = this.uuid.join()

				// get instances for this entity
				formResourcesManager.incrementCallToFinish()
				var url = '/cms/api/instances?where[entity]=' + this.entity.name + '&where[filters][0][property]=instances_uuid&where[filters][0][assertion]=in%20array&where[filters][0][value]=' + joinedArray
				xhrModule.get(url, this.fetchInstancesForEntity.bind(this))
			} else {
				// when there is no UUID found we have to let the main form know we are done with this editable reference block
				this.callback(null, this.entity.name)
			}
		},

		fetchInstancesForEntity: function (instances) {
			this.instances = instances
			formResourcesManager.subtractCallToFinish()
			if (!this.uuid) return
			var uuidsToRender = this.uuid

			if (instances.data.length === 0) {
				// there was a value saved but we can't find the referenced items at all
				for (var u = 0; u < uuidsToRender.length; u++) {
					this.logOrphanedReference(uuidsToRender[u])
				}
				this.callback(null, this.entity.name)
				// every stored UUID was counted in totalFormsToRender but renders no block;
				// reconcile the top-level counter so the loader can still finish.
				this.reconcileMissingBlocks(uuidsToRender.length, 0)
			} else {
				// let the main form know that from here on new forms will be rendered and that the editable ref itself is done
				this.callback(null, this.entity.name)

				var blocksRendered = 0
				for (var k = 0; k < uuidsToRender.length; k++) {
					var matchedThisUuid = false
					for (var p = 0; p < instances.data.length; p++) {
						if (uuidsToRender[k] === instances.data[p].uuid && instances.data[p].market.locale === this.defaultLang.locale) {
							matchedThisUuid = true
							var obj = {}
							// add all instances with this UUID to the obj
							for (var ins = instances.data.length - 1; ins >= 0; ins--) {
								if (instances.data[p].uuid === instances.data[ins].uuid) {
									obj[instances.data[ins].id] = instances.data[ins]
								}
							}

							blocksRendered++
							this.createEditableReferenceBlock(obj, '')
						}
					}
					if (!matchedThisUuid) this.logOrphanedReference(uuidsToRender[k])
				}

				// reconcile any stored UUIDs that resolved to no block (deleted refs / missing
				// default-locale translation) so startUniformCounter can still reach totalFormsToRender.
				this.reconcileMissingBlocks(uuidsToRender.length, blocksRendered)
			}
		},

		// A UUID is stored on the parent entity but no matching instance exists at the default
		// locale (e.g. the referenced item was deleted without saving the parent). Log it so it
		// can be located and removed from the DB manually.
		logOrphanedReference: function (uuid) {
			console.error('[editableReference] Orphaned reference: entity "' + this.entity.name + '" references UUID ' + uuid + ' but no instance was found at default locale "' + this.defaultLang.locale + '". This UUID should be removed from the parent entity / DB.')
		},

		// Each stored UUID was counted in ItemContent.totalFormsToRender, but only resolvable
		// UUIDs render a block that calls startUniform. For every counted-but-unrendered UUID we
		// advance the top-level counter ourselves, otherwise it never reaches the total and the
		// "form-loading" loader hangs forever with no error.
		reconcileMissingBlocks: function (storedCount, blocksRendered) {
			var missing = storedCount - blocksRendered
			if (missing <= 0) return
			for (var m = 0; m < missing; m++) {
				this.startUniform(this.routeChangeSuccess)
			}
		},

		addEditableReferenceForm: function (e) {
			e.preventDefault()
			this.createEditableReferenceBlock(null, 'item-new collapsed')
		},

		createEditableReferenceBlock: function (instances, addClass) {
			this.counter('+')
			this.editableRefIntCounter('+')

			this.evalutateMaxItems()

			editableReferenceItem({
				instances: instances,
				allInstances: this.instances,
				addClass: addClass,
				permissions: this.permissions,
				editableReferencesContainer: this.editableReferencesContainer,
				languages: this.languages,
				entity: this.entity,
				routeChangeSuccess: this.routeChangeSuccess,
				editableRefInt: editableRefInt,
				startUniform: this.startUniform,
				referencedForm: this.referencedForm,
				referencedFormClone: this.referencedFormClone,
				defaultLang: this.defaultLang,
				counter: this.counter,
				editableRefIntCounter: this.editableRefIntCounter
			}).init()
		},

		evalutateMaxItems: function () {
			const maxEditableReferences = parseInt(this.maxEditableReferences)
			if (maxEditableReferences == 0 || !this.createButton) return

			if (this.count >= parseInt(this.maxEditableReferences)) {
				// disable button
				this.createButton.setAttribute('disabled', 'true')
			} else {
				// enable button
				this.createButton.removeAttribute('disabled')
			}
		},

		counter: function (operator) {
			if (operator === '+') {
				this.count++
			} else if (operator === '-') {
				this.count--
			}
		},

		editableRefIntCounter: function (operator) {
			if (operator === '+') {
				editableRefInt++
			} else if (operator === '-') {
				editableRefInt--
			}
		}
	}
}

export default editableReference
